import { EntityType } from '@/modules/entities/types/EntityType';
import { EntityKind } from '@/types/schema';

/**
 * Entity types that use "beneficiary designations" instead of "dispositions."
 */
const BENEFICIARY_DESIGNATION_ENTITY_TYPES: readonly EntityType[] = [
  'retirement-account',
  'insurance-account',
];

/**
 * Entity kinds that use "beneficiary designations" instead of "dispositions."
 */
const BENEFICIARY_DESIGNATION_ENTITY_KINDS: readonly EntityKind[] = [
  EntityKind.RetirementPersonalAccount,
  EntityKind.InsurancePersonalAccount,
];

/**
 * Returns true if the entity (kind or type) uses "beneficiary designations"
 * terminology instead of "dispositions."
 */
export function isBeneficiaryDesignationEntity(
  entity: EntityKind | EntityType | null | undefined
): boolean {
  if (!entity) return false;
  return (
    (BENEFICIARY_DESIGNATION_ENTITY_TYPES as readonly string[]).includes(
      entity
    ) ||
    (BENEFICIARY_DESIGNATION_ENTITY_KINDS as readonly string[]).includes(entity)
  );
}

/**
 * Returns true if the entity type uses "beneficiary designations" terminology
 * instead of "dispositions."
 */
export function isBeneficiaryDesignationEntityType(
  entityType: EntityType | null | undefined
): boolean {
  return isBeneficiaryDesignationEntity(entityType);
}

/**
 * Returns true if the entity kind uses "beneficiary designations" terminology
 * instead of "dispositions."
 */
export function isBeneficiaryDesignationEntityKind(
  entityKind: EntityKind | null | undefined
): boolean {
  return isBeneficiaryDesignationEntity(entityKind);
}
